const initialState = {
    isModalVisible: false,
  };
  
  const faqsModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_FAQS_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_FAQS_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default faqsModalReducer;
  